// extracted by mini-css-extract-plugin
export default {"error":"styles_error__-xQxn","options_block":"styles_options_block__HBBrM"};